//   only ids are fine

(function () {
  this.WorstCyclingLane = function (config) {
    var countryBaseClass = 'worst-cycling-lane__country';
    var detailBaseClass = 'worst-cycling-lane__detail';
    var slideBaseClass = 'worst-cycling-lane__country-slide';
    var detailImageBaseClass = 'worst-cycling-lane__detail__image-wrapper';
    var overlayBaseClass = 'worst-cycling-lane__detail__overlay';
    var voteBaseClass = 'worst-cycling-lane__votes-button';

    this.WorstCyclingLane.Config = {
      debug: config.debug || false,
      apiUrl: config.apiUrl,
      classNames: {
        country: {
          base: countryBaseClass,
        },
        detail: {
          base: detailBaseClass,
          userUploaded: detailBaseClass + '--user-uploaded',
        },
        detailImage: {
          base: detailImageBaseClass,
        },
        overlay: {
          base: overlayBaseClass,
          active: overlayBaseClass + '--active',
          hint: overlayBaseClass + '--vote-hint',
          thank: overlayBaseClass + '--thankyou',
          voted: overlayBaseClass + '--voted',
          warning: overlayBaseClass + '--warning',
        },
        share: {
          facebook:
            '.worst-cycling-lane__detail__overlay__share-button--facebook',
          twitter:
            '.worst-cycling-lane__detail__overlay__share-button--twitter',
        },
        slide: {
          base: slideBaseClass,
          userUploaded: slideBaseClass + '--user-uploaded',
        },
        vote: {
          base: voteBaseClass,
          loading: voteBaseClass + '--loading',
          value: voteBaseClass + '__value',
          voted: voteBaseClass + '--voted',
          userUploaded: voteBaseClass + '--user-uploaded',
        },
      },
      facebookId: config.facebookAppId,
      otherCountriesId: 'other',
    };
  };

  this.WorstCyclingLane(window.ys.worst_cycling_lane);

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      // Initialize services
      this.WorstCyclingLane.Logger = new this.WorstCyclingLane.LoggerService(
        this.WorstCyclingLane
      );
      this.WorstCyclingLane.UserData =
        new this.WorstCyclingLane.UserDataService(this.WorstCyclingLane);
      this.WorstCyclingLane.UserData.CleanupVotes();

      this.WorstCyclingLane.Detail = new this.WorstCyclingLane.DetailService(
        this.WorstCyclingLane
      );
      this.WorstCyclingLane.Slides = new this.WorstCyclingLane.SlideService(
        this.WorstCyclingLane
      );
      this.WorstCyclingLane.Slides.MarkUserSlides();
      this.WorstCyclingLane.Voter = new this.WorstCyclingLane.VoterService(
        this.WorstCyclingLane
      );
      this.WorstCyclingLane.Location =
        new this.WorstCyclingLane.LocationService(this.WorstCyclingLane);
      var voteButtons = document.querySelectorAll(
        '.' + this.WorstCyclingLane.Config.classNames.vote.base
      );
      if (voteButtons) {
        for (
          var buttonIndex = 0;
          buttonIndex < voteButtons.length;
          buttonIndex++
        ) {
          this.WorstCyclingLane.Voter.RegisterVoteButtonClickListener(
            voteButtons[buttonIndex]
          );
        }
      }
      var countrySlides = document.querySelectorAll(
        '.' + this.WorstCyclingLane.Config.classNames.country.base
      );
      for (
        var countrySlideIndex = 0;
        countrySlideIndex < countrySlides.length;
        countrySlideIndex++
      ) {
        var countryCode = countrySlides[countrySlideIndex].dataset.countryCode;
        if (countryCode) {
          this.WorstCyclingLane.Voter.UpdateVotesForCountry(countryCode);
        }
      }
    }.bind(this)
  );
}).bind(window)();

(function ($) {
  // Handles the reordering of slider items
  function reorderItemsViaUserData(slider) {
    var sliderLanes = slider.find('.worst-cycling-lane__country-slide');

    // Empty slider, skip it
    if (sliderLanes.length <= 1) {
      return;
    }

    var sliderLanesReordered = {
      first: [],
      user: [],
      other: [],
    };

    // Sort each lane based on user / first
    $.each(sliderLanes, function (index, laneElement) {
      var $_this = $(laneElement);
      if ($_this.data('first') === 'yes') {
        sliderLanesReordered.first.push(laneElement);
      } else if (
        $_this.hasClass(
          window.WorstCyclingLane.Config.classNames.slide.userUploaded
        )
      ) {
        sliderLanesReordered.user.push(laneElement);
      } else {
        sliderLanesReordered.other.push(laneElement);
      }
    });

    // No user lanes, no need to reorder
    if (sliderLanesReordered.user.length === 0) {
      return;
    }

    // Winning lane is always the first
    $.each(sliderLanesReordered.first, function (index, laneElement) {
      var $_this = $(laneElement);
      $_this.appendTo(slider);
    });
    // Show user lanes right after
    $.each(sliderLanesReordered.user, function (index, laneElement) {
      var $_this = $(laneElement);
      $_this.appendTo(slider);
    });
    // The rest is appended last
    $.each(sliderLanesReordered.other, function (index, laneElement) {
      var $_this = $(laneElement);
      $_this.appendTo(slider);
    });
  }

  // Owl Carousel for sliders
  $('document').ready(function () {
    if (!$.fn.owlCarousel) {
      return;
    }

    var $owlEventNavigation = $('.worst-cycling-lane__slider');

    var responsive = {
      0: {
        items: 2,
        margin: 10,
        stagePadding: 41.5,
        slideBy: 3,
        mouseDrag: false,
        touchDrag: true,
      },
      768: {
        items: 3,
        margin: 15,
        stagePadding: 97.5,
        slideBy: 3,
        mouseDrag: false,
        touchDrag: true,
      },
      1024: {
        items: 4,
        margin: 15,
        stagePadding: 125,
        slideBy: 4,
        mouseDrag: true,
        touchDrag: false,
      },
    };

    var OwlSettings = {
      dots: false,
      nav: true,
      loop: false,
      responsive: responsive,
      //stagePadding: 97.5,
      lazyLoad: true,
      autoWidth: true,
      navText: [
        '<svg class="left font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
        '<svg class="right font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
      ],
    };

    $owlEventNavigation.each(function () {
      var $_this = $(this);

      // Reorder items via user / first properties before loading owlCarousel to prevent potential issues
      reorderItemsViaUserData($_this);

      // Needed for moving to selected element
      $_this.children().each(function (index) {
        $(this).attr('data-position', index);
      });

      $_this.owlCarousel(OwlSettings);
    });

    // Move to selected element
    $(document).on(
      'click',
      '.worst-cycling-lane__country-slide .worst-cycling-lane__image-wrapper a, h3.worst-cycling-lane__country-slide__title',
      function () {
        var $_this = $(this);

        var slideElement = $_this.closest('.worst-cycling-lane__country-slide');
        var sliderElement = $_this.closest(
          '.worst-cycling-lane__country-slide'
        );

        sliderElement.trigger(
          'to.owl.carousel',
          parseInt(slideElement.data('position')) - 1
        );
      }
    );
  });
})(jQuery);
(function ($) {
  // Detail

  var DetailStorage = [];
  var detailElement = $('.worst-cycling-lane__detail');
  var detailButtonElement = $(
    '.worst-cycling-lane__detail .worst-cycling-lane__votes-button'
  );
  var detailLinkElement = $('.worst-cycling-lane__detail__overlay__link-field');

  var prevArrow = $('.worst-cycling-lane__detail__arrow--prev');
  var nextArrow = $('.worst-cycling-lane__detail__arrow--next');

  var xDown = null;
  var yDown = null;

  // Minimum amount of pixels the user must swipe horizontal in order to change the detail
  var xLeniency = 30;
  // Maximum amount of pixel the user can swipe vertically before ignoring the detail change
  var yLeniency = 40;

  var arrowClassVisible = 'worst-cycling-lane__detail__arrow--visible';

  function disableArrows() {
    if (prevArrow) {
      prevArrow.get(0).disabled = true;
    }
    if (nextArrow) {
      nextArrow.get(0).disabled = true;
    }
  }

  function enableArrows() {
    if (prevArrow.length > 0) {
      prevArrow.get(0).disabled = false;
    }
    if (nextArrow.length > 0) {
      nextArrow.get(0).disabled = false;
    }
  }

  function resetSwipeValues() {
    xDown = null;
    yDown = null;
  }

  function usedSwipe() {
    this.WorstCyclingLane.UserData.SetUsedSwipe();
  }

  function findSlideInSlider(slider, index) {
    var slide = slider.find(
      '.worst-cycling-lane__country-slide[data-position=' + index + ']'
    );

    if (slide.length) {
      return slide;
    }

    return null;
  }

  function moveDetailInCurrentSlider(position) {
    var currentSlide = $('.worst-cycling-lane__country-slide.active');
    var currentCountrySlider = currentSlide.closest(
      '.worst-cycling-lane__slider'
    );
    var currentSlideIndex = currentSlide.data('position');
    var newSlide = findSlideInSlider(
      currentCountrySlider,
      currentSlideIndex + position
    );

    if (newSlide) {
      newSlide.find('.worst-cycling-lane__image-wrapper a').trigger('click');
    }
  }

  function populateDetail(data, isFirst) {
    $('.worst-cycling-lane__detail__title').html(data.title);
    $('.worst-cycling-lane__detail__name').html(data.name);
    $('.worst-cycling-lane__detail__location').html(data.location);
    $('.worst-cycling-lane__detail__country').html(data.country);
    $('.worst-cycling-lane__detail__date').html(data.createdAt);
    $('.worst-cycling-lane__detail__image').attr('src', data.image);
    $(
      '.worst-cycling-lane__detail .worst-cycling-lane__votes-button__value'
    ).html(data.votes);

    detailButtonElement.attr('data-id', data.postId);
    detailElement.attr('data-id', data.postId);

    detailButtonElement.attr('data-country', data.countryCode);
    detailElement.attr('data-country', data.countryCode);

    detailLinkElement.attr(
      'value',
      window.location.origin +
        window.location.pathname +
        '?lane-id=' +
        data.postId
    );

    if (isFirst === 'yes') {
      detailElement.addClass('worst-cycling-lane__detail--first');
    } else {
      detailElement.removeClass('worst-cycling-lane__detail--first');
    }

    window.WorstCyclingLane.Detail.Open(data.postId, data.countryCode);
  }

  function maybeRegisterSwipe(xUp, yUp) {
    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    var absXDiff = Math.abs(xDiff);
    var absYDiff = Math.abs(yDiff);

    // Do not register swipes up/down higher than leniency value
    if (absYDiff > yLeniency) {
      resetSwipeValues();
      return;
    }

    // Register swipes bigger than leniency value
    if (absXDiff < xLeniency) {
      return;
    }

    if (absXDiff > absYDiff) {
      if (xDiff > 0) {
        // Right swipe
        moveDetailInCurrentSlider(+1);
        usedSwipe();
      } else {
        // Left swipe
        moveDetailInCurrentSlider(-1);
        usedSwipe();
      }
    }

    // Reset values
    resetSwipeValues();
  }

  $(document).on(
    'click',
    '.worst-cycling-lane__country-slide .worst-cycling-lane__image-wrapper a, h3.worst-cycling-lane__country-slide__title',
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).find('img').fadeTo('slow', 0.9).fadeTo('slow', 1);
      detailElement.addClass('loading');

      var slideElement = $(this).closest('.worst-cycling-lane__country-slide');
      var sliderSection = $(this).closest(
        'section.worst-cycling-lane__country'
      );

      var postId = slideElement.data('id');
      var votes = slideElement.data('votes');
      var isFirst = slideElement.data('first');
      var country = slideElement.data('country');
      var fetchUrl =
        window.ys.rest_url + 'ys/worst-cycling-lane/v1/detail/' + postId;

      $('.worst-cycling-lane__country-slide').removeClass('active');
      slideElement.addClass('active');

      var currentCountrySlider = slideElement.closest(
        '.worst-cycling-lane__slider'
      );
      var currentSlideIndex = slideElement.data('position');
      var prevPossible = parseInt(currentSlideIndex, 10) - 1;
      var nextPossible = parseInt(currentSlideIndex, 10) + 1;

      window.WorstCyclingLane.Detail.Close();

      if (typeof DetailStorage[postId] === 'undefined') {
        fetch(fetchUrl, {})
          .then(function (response) {
            return response.json();
          })
          .then(function (result) {
            DetailStorage[postId] = result.data;
            DetailStorage[postId].postId = postId;
            DetailStorage[postId].votes = votes;
            DetailStorage[postId].countryCode = country;

            populateDetail(DetailStorage[postId], isFirst);
            detailElement.appendTo(sliderSection);
            detailElement.addClass('active');
            detailElement.removeClass('loading');
            window.WorstCyclingLane.Detail.ScrollToDetail();
            enableArrows();
          });
      } else {
        populateDetail(DetailStorage[postId], isFirst);
        detailElement.appendTo(sliderSection);
        detailElement.addClass('active');
        detailElement.removeClass('loading');
        window.WorstCyclingLane.Detail.ScrollToDetail();
        enableArrows();
      }

      var prevSlide = findSlideInSlider(currentCountrySlider, prevPossible);
      if (prevSlide) {
        prevArrow.addClass(arrowClassVisible);
      } else {
        prevArrow.removeClass(arrowClassVisible);
      }
      var nextSlide = findSlideInSlider(currentCountrySlider, nextPossible);
      if (nextSlide) {
        nextArrow.addClass(arrowClassVisible);
      } else {
        nextArrow.removeClass(arrowClassVisible);
      }
    }
  );

  $(window).on('load', function () {
    if ($(document).find('.worst-cycling-lane__country-slide.active')[0]) {
      $(document)
        .find(
          '.worst-cycling-lane__country-slide.active .worst-cycling-lane__image-wrapper a'
        )
        .trigger('click');
    }
  });

  detailElement.on('touchstart', function (e) {
    if (e.targetTouches.length > 0) {
      xDown = e.targetTouches[0].clientX;
      yDown = e.targetTouches[0].clientY;
    }
  });

  detailElement.on('mousedown', function (e) {
    xDown = e.clientX;
    yDown = e.clientY;
  });

  detailElement.on('mouseup', function (e) {
    if (xDown === null || yDown === null) {
      return;
    }

    if (
      e.target.classList.contains(
        'worst-cycling-lane__detail__overlay__link-field'
      )
    ) {
      return;
    }

    maybeRegisterSwipe(e.clientX, e.clientY);

    resetSwipeValues();
  });

  detailElement.on('touchmove', function (e) {
    if (xDown === null || yDown === null) {
      return;
    }

    if (e.targetTouches.length < 1) {
      return;
    }

    maybeRegisterSwipe(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
  });

  detailElement.on('touchend', resetSwipeValues);

  prevArrow.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    disableArrows();
    moveDetailInCurrentSlider(-1);
    usedSwipe();
  });

  nextArrow.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    disableArrows();
    moveDetailInCurrentSlider(+1);
    usedSwipe();
  });

  $('.worst-cycling-lane__detail__overlay__close').on('click', function (e) {
    e.stopPropagation();
    $(this).parent().removeClass('worst-cycling-lane__detail__overlay--active');
    usedSwipe();
  });

  $('.worst-cycling-lane__detail__overlay__link').on('click', function (e) {
    e.stopPropagation();
  });

  $('.worst-cycling-lane__votes-share').on('click', function (e) {
    var activeDiv = document.querySelector(
      '.worst-cycling-lane__detail__overlay--active'
    );
    if (activeDiv !== null) {
      $(activeDiv).removeClass('worst-cycling-lane__detail__overlay--active');
    }
    $('.worst-cycling-lane__detail__overlay--share').addClass(
      'worst-cycling-lane__detail__overlay--active'
    );
    $('.worst-cycling-lane__detail__overlay__link-field').select();
  });

  $('.worst-cycling-lane__detail__overlay__link-field').on(
    'click blur focus',
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).select();
    }
  );

  $('.worst-cycling-lane__detail__overlay__link-wrapper').on(
    'click',
    function (e) {
      e.stopPropagation();
    }
  );

  $('.worst-cycling-lane__detail__overlay__link-copy').on(
    'click',
    function (e) {
      var copyText = $('.worst-cycling-lane__detail__overlay__link-field');
      copyText.select();
      document.execCommand('copy');
    }
  );

  function isInViewport(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  $(window).scroll(function () {
    if (
      !isInViewport($('.worst-cycling-lane__add-photo')) &&
      $('.worst-cycling-lane__mobile-add-button').is(':hidden')
    ) {
      $('.worst-cycling-lane__add-photo-header').addClass(
        'worst-cycling-lane__add-photo-header--active'
      );
    } else {
      $('.worst-cycling-lane__add-photo-header').removeClass(
        'worst-cycling-lane__add-photo-header--active'
      );
    }
  });
})(jQuery);
